import React, {Component} from 'react';
import converter from 'number-to-words';
import $ from 'jquery';
import moment from 'moment';
import {Title, Noun, UnCurrency, SubjectVerb, Pronoun, SingularPluralForm} from '../../../../model/Helper';
import PaperSignatories from '../../../../view/PaperSignatories';
import PaperSignatoriesAcknowledgement from '../../../../view/PaperSignatoriesAcknowledgement';
import PaperParty from '../../../../view/PaperParty';
import WitnessBlock from '../../../../view/WitnessBlock';
import {blank_line} from '../../../../model/Const';

class Preview extends Component {

    constructor(props) {
        super(props);
        this.state = {
            focus: ".paper-title"
        }
    }

    isVisible(el) {
		var elementTop = $(el).offset().top;
		var elementBottom = elementTop + $(el).outerHeight();
	
		var viewportTop = $(window).scrollTop();
		var viewportBottom = viewportTop + $(window).height();
	
		return elementBottom > viewportTop && elementTop < viewportBottom;
    }

    componentDidMount() {

		$(window).scroll(()=>{

			// This setup will be enabled only with at least md window width
			if($(window).width()>767){
				// Header setup
				// Make preview stay at the top and fixed display when header is not visible
				if(this.isVisible(".header")){
					////console.log("Visible");
					$(".right-preview .preview").css({
						"position": "relative",
						"top": "auto",
						"padding-right": "0"
					});
				} else {
					////console.log("Not visible");
					$(".right-preview .preview").css({
						"position": "fixed",
						"top": "1rem",
						"padding-right": "15px"
					});
				}

			}
        });
        
    }
    
    componentWillReceiveProps(newProps) {
        
        let ff = newProps.formFocus?newProps.formFocus:'paper-title';

        this.setState({
            focus: '.'+ff
        }, ()=>{
            //console.log(this.state.focus)
            let screenPos = $(window).height()/3;
            let el = $(this.state.focus).length?$(this.state.focus):$(".paper-title");
            let scrollVal = el.get(0).offsetTop-screenPos || 0;
            
            $(".paper").animate({
                scrollTop: scrollVal
            }, 100);
            
        });

    }

    render() {

        let p = this.props.details.property;
        let s = this.props.details.seller;
        let b = this.props.details.buyer;
        let pa = this.props.details.payment;

        /**
         * Noun / Pronoun
         */
        let nounSeller = Noun(s, "seller");
        let nounBuyer  = Noun(b, "buyer");

        let blankLine = blank_line;

        let title = Title(p) || blankLine;
        let pAddress = p.address || blankLine;
        let pType = blankLine;
        if(p.type==="Condominium"){
            pType = `condominium`;
        }
        if(p.type==="Land"){
            pType = `parcel of land`;
        }
        if(p.type==="Land with Improvement"){
            pType = `parcel of land, together with its improvement`;
        }

        // Natural person variables
        let sellerName = [], 
            sellerSpouseName = [],
            sellerNationality = [],
            sellerAddress = [],
            sellerRepresentativeName = [],
            sellerRepresentativeNationality = [],
            sellerRepresentativeAddress = [],
            sellerTin = [];
        // Corporation variables
        let sellerCorporationName = [],
            sellerCorporationPrincipalPlaceOfBusiness = [],
            sellerCorporationRepresentativeName = [],
            //sellerCorporationRepresentativePosition = [],
            sellerCorporationTin = [];
        this.props.details.seller.forEach((seller, i)=>{
            sellerName[i] = (seller.sellerFname || seller.sellerMname || seller.sellerLname) ? 
                                    (seller.sellerFname+(seller.sellerMname?` ${seller.sellerMname}`:"")+(seller.sellerLname?` ${seller.sellerLname}`:"")+(seller.sellerSuffix?` ${seller.sellerSuffix}`:"")): 
                                    blankLine;
            sellerSpouseName[i] = (seller.sellerSpouseFname || seller.sellerSpouseMname || seller.sellerSpouseLname) ? 
            (seller.sellerSpouseFname+(seller.sellerSpouseMname?` ${seller.sellerSpouseMname}`:"")+(seller.sellerSpouseLname?` ${seller.sellerSpouseLname}`:"")+(seller.sellerSpouseSuffix?` ${seller.sellerSpouseSuffix}`:"")): 
            blankLine;
            sellerNationality[i] = seller.sellerNationality ? seller.sellerNationality : blankLine;
            sellerAddress[i] = seller.sellerAddress ? seller.sellerAddress :  blankLine;
            
            sellerRepresentativeName[i] = (seller.sellerRepresentativeFname || seller.sellerRepresentativeMname || seller.sellerRepresentativeLname) ? 
                                    (seller.sellerRepresentativeFname+(seller.sellerRepresentativeMname?` ${seller.sellerRepresentativeMname}`:"")+(seller.sellerRepresentativeLname?` ${seller.sellerRepresentativeLname}`:"")+(seller.sellerRepresentativeSuffix?` ${seller.sellerRepresentativeSuffix}`:"")): 
                                    blankLine;
            sellerRepresentativeNationality[i] = seller.sellerRepresentativeNationality ? seller.sellerRepresentativeNationality : blankLine;
            sellerRepresentativeAddress[i] = seller.sellerRepresentativeAddress ? seller.sellerRepresentativeAddress :  blankLine;
            sellerTin[i] = seller.sellerTin ? seller.sellerTin : "";

            sellerCorporationName[i] = seller.sellerCorporationName ? seller.sellerCorporationName : blankLine;
            sellerCorporationPrincipalPlaceOfBusiness[i] = seller.sellerCorporationPrincipalPlaceOfBusiness ? seller.sellerCorporationPrincipalPlaceOfBusiness : blankLine;
            
            sellerCorporationRepresentativeName[i] = (seller.sellerCorporationRepresentativeFname || seller.sellerCorporationRepresentativeMname || seller.sellerCorporationRepresentativeLname) ? 
                                    (seller.sellerCorporationRepresentativeFname+(seller.sellerCorporationRepresentativeMname?` ${seller.sellerCorporationRepresentativeMname}`:"")+(seller.sellerCorporationRepresentativeLname?` ${seller.sellerCorporationRepresentativeLname}`:"")+(seller.sellerCorporationRepresentativeSuffix?` ${seller.sellerCorporationRepresentativeSuffix}`:"")): 
                                    blankLine;
            sellerCorporationTin[i] = seller.sellerCorporationTin ? seller.sellerCorporationTin : "";
        });

        // Natural person variables
        let buyerName = [], 
            buyerSpouseName = [],
            buyerNationality = [],
            buyerAddress = [],
            buyerRepresentativeName = [],
            buyerRepresentativeNationality = [],
            buyerRepresentativeAddress = [],
            buyerTin = [];
        // Corporation variables
        let buyerCorporationName = [],
            buyerCorporationPrincipalPlaceOfBusiness = [],
            buyerCorporationRepresentativeName = [];
        this.props.details.buyer.forEach((buyer, i)=>{
            buyerName[i] = (buyer.buyerFname || buyer.buyerMname || buyer.buyerLname) ? 
                                    (buyer.buyerFname+(buyer.buyerMname?` ${buyer.buyerMname}`:"")+(buyer.buyerLname?` ${buyer.buyerLname}`:"")+(buyer.buyerSuffix?` ${buyer.buyerSuffix}`:"")): 
                                    blankLine;
            buyerSpouseName[i] = (buyer.buyerSpouseFname || buyer.buyerSpouseMname || buyer.buyerSpouseLname) ? 
            (buyer.buyerSpouseFname+(buyer.buyerSpouseMname?` ${buyer.buyerSpouseMname}`:"")+(buyer.buyerSpouseLname?` ${buyer.buyerSpouseLname}`:"")+(buyer.buyerSpouseSuffix?` ${buyer.buyerSpouseSuffix}`:"")): 
            blankLine;
            buyerNationality[i] = buyer.buyerNationality ? buyer.buyerNationality : blankLine;
            buyerAddress[i] = buyer.buyerAddress ? buyer.buyerAddress :  blankLine;
            
            buyerRepresentativeName[i] = (buyer.buyerRepresentativeFname || buyer.buyerRepresentativeMname || buyer.buyerRepresentativeLname) ? 
                                    (buyer.buyerRepresentativeFname+(buyer.buyerRepresentativeMname?` ${buyer.buyerRepresentativeMname}`:"")+(buyer.buyerRepresentativeLname?` ${buyer.buyerRepresentativeLname}`:"")+(buyer.buyerRepresentativeSuffix?` ${buyer.buyerRepresentativeSuffix}`:"")): 
                                    blankLine;
            buyerRepresentativeNationality[i] = buyer.buyerRepresentativeNationality ? buyer.buyerRepresentativeNationality : blankLine;
            buyerRepresentativeAddress[i] = buyer.buyerRepresentativeAddress ? buyer.buyerRepresentativeAddress :  blankLine;

            buyerCorporationName[i] = buyer.buyerCorporationName ? buyer.buyerCorporationName : blankLine;
            buyerCorporationPrincipalPlaceOfBusiness[i] = buyer.buyerCorporationPrincipalPlaceOfBusiness ? buyer.buyerCorporationPrincipalPlaceOfBusiness : blankLine;
            
            buyerCorporationRepresentativeName[i] = (buyer.buyerCorporationRepresentativeFname || buyer.buyerCorporationRepresentativeMname || buyer.buyerCorporationRepresentativeLname) ? 
                                    (buyer.buyerCorporationRepresentativeFname+(buyer.buyerCorporationRepresentativeMname?` ${buyer.buyerCorporationRepresentativeMname}`:"")+(buyer.buyerCorporationRepresentativeLname?` ${buyer.buyerCorporationRepresentativeLname}`:"")+(buyer.buyerCorporationRepresentativeSuffix?` ${buyer.buyerCorporationRepresentativeSuffix}`:"")): 
                                    blankLine;
            buyerTin[i] = buyer.buyerTin ? buyer.buyerTin : "";
 
        });

        let price = UnCurrency(p.price);
        let priceNumber = (typeof parseFloat(price) === "number" && parseFloat(price)>0) ?
                                Number(price).toLocaleString(undefined, {minimumFractionDigits:2, maximumFractionDigits:2}) :
                                blankLine;		
        let priceText = (typeof parseFloat(price) === "number" && parseFloat(price)>0) ?
                            converter.toWords(price) : 
                            blankLine;
    
        let buyersPayArray = [];
        let sellersPayArray = [];
        pa.capitalGainTax === "seller" ?
            sellersPayArray.push("capital gain tax"):
            buyersPayArray.push("capital gain tax");
        pa.documentaryStampTax === "seller" ?
            sellersPayArray.push("documentary stamp tax"):
            buyersPayArray.push("documentary stamp tax");
        pa.transferTax === "seller" ?
            sellersPayArray.push("transfer tax"):
            buyersPayArray.push("transfer tax");
        pa.registrationFee === "seller" ?
            sellersPayArray.push("registration fee"):
            buyersPayArray.push("registration fee");
        pa.notarialFee === "seller" ?
            sellersPayArray.push("notarial fee") :
            buyersPayArray.push("notarial fee");
        if(pa.hasBroker === "Yes"){
            pa.brokerCommission === "seller" ?
                sellersPayArray.push("broker's commission") :
                buyersPayArray.push("broker's commission");
        }
        pa.creditableWithholdingTax === "seller" ?
            sellersPayArray.push("creditable withholding tax") :
            buyersPayArray.push("creditable withholding tax");
        pa.valueAddedTax === "seller" ?
            sellersPayArray.push("value added tax") :
            buyersPayArray.push("value added tax");
        let sellersPay = sellersPayArray.join(", ");
        let buyersPay = buyersPayArray.join(", ");

        //let earnestMoneyAmount = p.earnestMoneyAmount ? p.earnestMoneyAmount : blankLine;

        // Create this into array so we can use map inside JSX
        let scheduleOfPaymentsDates = [];
        for(let i=0; i<p.monthsToPayBalance; i++) {
            scheduleOfPaymentsDates.push({
                "count": i,
                "amort": (p.price-p.downpayment-p.earnestMoneyAmount)/p.monthsToPayBalance,
                "date": `${moment(p.firstInstallmentDue).add(i, 'month').format('LL')}`
            })
        }

        let surrenderCondominium = [];
        let surrenderLand = [];
        let surrenderLandWithImprovement = [];
        if(p.type){
            if(p.type==="Condominium"){
                if(p.surrenderCct==="Yes"){
                    surrenderCondominium.push(`Owner’s Duplicate Original Copy of CCT ${p.ctn};`);
                }
                if(p.surrenderLatestTaxDeclarationOnCondominium==="Yes"){
                    surrenderCondominium.push(`Latest Tax Declaration on the land;`);
                }
                if(p.surrenderTaxClearanceCertificate==="Yes"){
                    surrenderCondominium.push(`Tax Clearance Certificate`);
                }
            }
            if(p.type==="Land"){
                if(p.registrationType==="oct"){
                    if(p.surrenderOct==="Yes"){
                        surrenderLand.push(`Owner’s Duplicate Original Copy of OCT ${p.oct};`);
                    }
                }
                if(p.registrationType==="tct"){
                    if(p.surrenderTct==="Yes"){
                        surrenderLand.push(`Owner’s Duplicate Original Copy of TCT ${p.tct};`);
                    }
                }
                if(p.surrenderLatestTaxDeclarationOnLand==="Yes"){
                    surrenderLand.push(`Latest Tax Declaration on the land;`);
                }
                if(p.surrenderTaxClearanceCertificateOnLand==="Yes"){
                    surrenderLand.push(`Tax Clearance Certificate for the land;`);
                }
            }
            if(p.type==="Land with Improvement"){
                if(p.registrationType==="oct"){
                    if(p.surrenderOct==="Yes"){
                        surrenderLandWithImprovement.push(`Owner’s Duplicate Original Copy of OCT ${p.oct};`);
                    }
                }
                if(p.registrationType==="tct"){
                    if(p.surrenderTct==="Yes"){
                        surrenderLandWithImprovement.push(`Owner’s Duplicate Original Copy of TCT ${p.tct};`);
                    }
                }
                if(p.surrenderLatestTaxDeclarationOnLand==="Yes"){
                    surrenderLandWithImprovement.push(`Latest Tax Declaration on the land;`);
                }
                if(p.surrenderLatestTaxDeclarationOnImprovment==="Yes"){
                    surrenderLandWithImprovement.push(`Latest Tax Declaration on the improvement;`);
                }
                if(p.surrenderTaxClearanceCertificateOnLand==="Yes"){
                    surrenderLandWithImprovement.push(`Tax Clearance Certificate for the land;`);
                }
                if(p.surrenderTaxClearanceCertificateOnImprovement==="Yes"){
                    surrenderLandWithImprovement.push(`Tax Clearance Certificate on the improvement`);
                }
            }
        }

        return (
            <div className="preview">
                <div className="default-preview-fade top"></div>
                <div className="top-preview">
                    <div className="text-center">
                        <p>Preview</p>
                    </div>

                    <div className="paper">
                    <div className="paper-inner">
                        
                        <div className="paper-title text-center">
							Deed of Absolute Sale
						</div>

                        <div className="text-uppercase">
                            <p className="no-indent">
                                KNOW ALL MEN BY THESE PRESENTS:
                            </p>
                        </div>

                        <div>
                            <p>
                            This Deed of Absolute Sale (hereinafter “Deed”) made and entered into this _______________ in _______________, Philippines, by and between:
                            </p>
                        </div>

                        <PaperParty party={s} type="seller" />

                        <div className="paper-narrow my-3 text-center">
                            <div className="my-3">- and -</div>
                        </div>

                        <PaperParty party={b} type="buyer" />

                        <div className="paper-narrow my-3 text-center">
                            <div className="my-3"><strong>WITNESSETH</strong>: That-</div>
                        </div>

                        <div>
                            <p>
                                WHEREAS, the <span className="text-uppercase">{nounSeller}</span> {SubjectVerb(nounSeller, "is")} the absolute and registered {SingularPluralForm(nounSeller, "owner")} of a <span className="dynamic-data property_type">{pType}</span> (hereinafter “Subject Real Property”), situated at <span className="dynamic-data text-capitalize property_address">{pAddress}</span> and covered by <span className="dynamic-data text-uppercase property_ctn property_registrationType property_tct property_oct">{title}</span>. A copy of this title is hereto attached and made an integral part hereof.
                            </p>
                        </div>
                                
                        <div>
                            <p>
                                WHEREAS, the <span className="text-uppercase">{nounSeller}</span> {SubjectVerb(nounSeller, "has")} offered to sell to the <span className="text-uppercase">{nounBuyer}</span>, and the <span className="text-uppercase">{nounBuyer}</span> {SubjectVerb(nounBuyer, "has")} agreed to purchase from the <span className="text-uppercase">{nounSeller}</span>, the Subject Real Property;
                            </p>
                        </div>

                        <div>
                            <p>
                                NOW THEREFORE, for and in consideration of the foregoing premises and the payment of the purchase price hereinafter specified, the <span className="text-uppercase">{nounSeller}</span> hereby sell, transfer and convey unto the <span className="text-uppercase">{nounBuyer}</span> the Subject Real Property under the terms and conditions specified below:    
                            </p>
                        </div>

                        <div className="section1 my-3">
                            <h5 className="my-3">SECTION 1. <u>PURCHASE PRICE</u></h5>
                            <p>
                                1.1. &emsp; The purchase price of the Subject Real Property under this Deed is <span className="dynamic-data text-uppercase property_price">{priceText}</span> PESOS (P<span className="dynamic-data">{priceNumber}</span>) Philippine Currency (hereinafter “Purchase Price”), receipt of which is hereby acknowledged by the <span className="text-uppercase">{nounSeller}</span> from the <span className="text-uppercase">{nounBuyer}</span> to their full and complete satisfaction.  
                            </p> 
                        </div>

                        <div className="section2 my-3">
                            <h5 className="my-3">SECTION 2. <u>RECEIPT OF TITLE</u></h5>
                            <p>
                                2.1. &emsp; The <span className="text-uppercase">{nounBuyer}</span> hereby {SubjectVerb(nounBuyer, "acknowledges")} receipt from the <span className="text-uppercase">{nounSeller}</span> of the following documents, to wit:
                            </p>
                            <div className="ml-5 property_surrenderOct property_surrenderLatestTaxDeclarationOnLand property_surrenderTaxClearanceCertificateOnLand">
                                <ol type="a" className={p.type==="Condominium"?``:`d-none`}>
                                    {
                                        surrenderCondominium.map((obj, i)=>{
                                            return(
                                                <li key={i}><span className="dynamic-data">{obj}</span></li>
                                            )
                                        })
                                    }
                                </ol>
                                <ol type="a" className={p.type==="Land"?``:`d-none`}>
                                    {
                                        surrenderLand.map((obj, i)=>{
                                            return(
                                                <li key={i}><span className="dynamic-data">{obj}</span></li>
                                            )
                                        })
                                    }
                                </ol>
                                <ol type="a" className={p.type==="Land with Improvement"?``:`d-none`}>
                                    {
                                        surrenderLandWithImprovement.map((obj, i)=>{
                                            return(
                                                <li key={i}><span className="dynamic-data">{obj}</span></li>
                                            )
                                        })
                                    }
                                </ol>
                            </div>

                        </div>

                        <div className="section3 my-3">
                            <h5 className="my-3">SECTION 3. <u>WARRANTIES OF THE SELLER</u></h5>
                            <p>
                                3.1. &emsp; The <span className="text-uppercase">{nounSeller}</span> represent and warrant to the <span className="text-uppercase">{nounBuyer}</span> that:
                            </p>
                            <div className="ml-5">
                                <ol type="a">
                                    <li>
                                        {Pronoun("he", s[0].sellerGender, s[0].legalPersonality, nounSeller)} {SubjectVerb(nounSeller, "has")} all the requisite rights, power and authority to comply with the provisions of this Deed. <span className="ucfirst">{Pronoun("he", s[0].sellerGender, s[0].legalPersonality, nounSeller)}</span> also {SubjectVerb(nounSeller, "has")} the power to deliver and sell the Subject Real Property and to carry out all obligations under this Deed;
                                    </li>
                                    <li>
                                        <span className="ucfirst">{Pronoun("he", s[0].sellerGender, s[0].legalPersonality, nounSeller)}</span> {SubjectVerb(nounSeller, "is")} the lawful, beneficial and registered owner of the Subject Real Property;
                                    </li>
                                    <li>
                                        Upon execution of the Deed, the <span className="text-uppercase">{nounBuyer}</span>{nounBuyer==='buyers'?`'`:`'s`} full payment of the corresponding purchase price and delivery of the Subject Real Property by the <span className="text-uppercase">{nounSeller}</span>, the <span className="text-uppercase">{nounBuyer}</span> will receive good title to it, free and clear of all encumbrances;
                                    </li>
                                    <li>
                                        All the property taxes on the Subject Real Property, including interest, penalties or other tax assessments, with respect thereto, have been paid by the<span className="text-uppercase"> {nounSeller}</span>. There is no pending or potential assessments for unpaid and deficiency taxes, assessments, penalties, interest which constitute or will constitute a lien or encumbrance on the Subject Real Property; and
                                    </li>
                                    <li>
                                        <span className="ucfirst">{Pronoun("he", s[0].sellerGender, s[0].legalPersonality, nounSeller)}</span> will defend the <span className="text-uppercase">{nounBuyer}</span> from any reasonable claims of lawful title made by third parties. Furthermore, {Pronoun("he", s[0].sellerGender, s[0].legalPersonality, nounSeller)} {SubjectVerb(nounSeller, "assures")} the <span className="text-uppercase">{nounBuyer}</span> that {Pronoun("he", s[0].sellerGender, s[0].legalPersonality, nounSeller)} will compensate it for any loss sustained by reason of such claim.
                                    </li>
                                </ol>
                            </div>

                        </div>

                        <div className="section4 my-3">
                            <h5 className="my-3">SECTION 4. <u>WARRANTIES OF THE <span className="text-uppercase">{nounBuyer}</span></u></h5>
                            <p>
                                4.1. &emsp; The <span className="text-uppercase">{nounBuyer}</span> represents and warrants to the <span className="text-uppercase">{nounSeller}</span> that:
                            </p>
                            <div className="ml-5">
                                <ol type="a">
                                    <li>
                                        The <span className="text-uppercase">{nounBuyer}</span> {SubjectVerb(nounBuyer, "has")} the right, power, authority and full legal capacity to comply with the provisions of this Deed. <span className="ucfirst">{Pronoun("it", b[0].buyerGender, b[0].legalPersonality, nounBuyer)}</span> {SubjectVerb(nounBuyer, "has")} the power to buy the Subject Real Property and consummate the transaction contemplated hereby.
                                    </li>
                                </ol>
                            </div>
                        </div>

                        <div className="section5 my-3 payment_capitalGainTax payment_documentaryStampTax payment_transferTax payment_registrationFee payment_notarialFee payment_hasBroker payment payment_brokerCommission payment_creditableWithholdingTax payment_valueAddedTax">
                            <h5 className="my-3">SECTION 5. <u>TAXES, FEES AND EXPENSES</u></h5>
                            <p>
                                5.1. &emsp; <span className="dynamic-data">{buyersPayArray.length>0?`The ${buyersPay}, and other`:`Other`}</span> necessary expenses connected with this Contract, the Deed of Absolute Sale and the issuance of the corresponding title for the Subject Real Property in the name of the <span className="text-uppercase">{nounBuyer}</span> shall be for the account of and paid by the <span className="text-uppercase">{nounBuyer}</span>.
                            </p>
                            <p>
                                5.2. &emsp; <span className="dynamic-data">{sellersPayArray.length>0?`The ${sellersPay}, whichever`:`Whichever`}</span> is applicable, shall be for the account of and paid by the <span className="text-uppercase">{nounSeller}</span>.
                            </p>
                            <p>
                                5.3. &emsp; The <span className="text-uppercase">{nounSeller}</span> shall update the real property taxes prior to the delivery of the Subject Real Property. From and after the said delivery, any and all real property taxes accruing on the said property shall be for the account of the <span className="text-uppercase">{nounBuyer}</span>.
                            </p>
                        </div>
                        
                        <br />
                        <br />

                        <div>
                            <p>
                                IN WITNESS WHEREOF, the parties have executed this Contract on the date and in the place first above written.
                            </p>
                        </div>

                        <br />
                        <br />

                        <PaperSignatories party1={s} party2={b} />
                        
                        <br /><br /><br />
                        
                        <WitnessBlock />

                        <br /><br />

                        <hr />

                        <br /><br />
                        
                        {
                        /**
                         * Acknowledgement section
                         */
                        }
                        <div className="paper-top-left d-inline-block">
							<div>REPUBLIC OF THE PHILIPPINES )</div>
							<div>)S.S.</div>
						</div>

                        <div className="paper-title text-center">
							Acknowledgement
						</div>

                        <div>
                            <p>
                                BEFORE ME, a Notary Public for and in the above jurisdiction, this _______________, personally appeared the following:
                            </p>
                        </div>

                        <PaperSignatoriesAcknowledgement party1={s} party2={b} />

                        <div>
                            <p>
                                Known to me and to me known to be the same persons who executed the foregoing Deed of Absolute Sale consisting of <span className="dynamic-data"><small className="text-muted font-italic">[to be filled up by the system]</small></span> pages, including this page where the acknowledgement is written, signed by the parties on each and every page hereof, and acknowledged to me that the same is their free and voluntary act and deed.
                            </p>
                            <p>
                                WITNESS MY HAND AND SEAL in the place and on the date first above written.
                            </p>
                        </div>

                        <br />
                        <br />
                        <div className="docno">
							Doc No. ________; <br />
							Page No. _______; <br />
							Book No. _______; <br />
							Series of 20 ___. <br />
						</div>

                    </div>
                    </div> {/** End of paper */}

                </div>

                <div className="default-preview-fade"></div>
            </div>
        );
    }

}

export default Preview;



// WEBPACK FOOTER //
// ./src/pages/contracts/real-estate/deed-of-absolute-sale/Preview.js